import {defineStore} from 'pinia';
import {ModuleArea} from '../moduleConst';
import {BaseDictionaryStore} from '../baseDictionaryStore';
import areaAPI from '@/apis/di/areaAPI';

const areaStore = new BaseDictionaryStore(areaAPI);

export const useAreaStore = defineStore(ModuleArea, {
  state: () => ({
    ...areaStore.state,
    _config: {
      key: 'area_id',
      code: 'area_code',
      name: 'area_name',
      table: 'di_area',
      quickFollow: 'active',
      moduleName: 'Khu vực',
      defaultSort: 'area_code',
    },
    moduleName: ModuleArea,
    
    // Cache thông tin khu vực cho lần thêm mới tiếp theo
    cachedAreaInfo: null,
  }),
  actions: {
    ...areaStore.action,
    
    /**
     * Lưu thông tin khu vực vào cache cho lần thêm mới tiếp theo
     * @param {Object} areaInfo - Thông tin khu vực {area_id, area_name, formName}
     */
    setCachedAreaInfo(areaInfo) {
      if (areaInfo && areaInfo.area_id && areaInfo.area_name) {
        this.cachedAreaInfo = {
          area_id: areaInfo.area_id,
          area_name: areaInfo.area_name,
          formName: areaInfo.formName || null, // Lưu tên form để kiểm tra
        };
      }
    },

    /**
     * Lấy thông tin khu vực từ cache
     * @returns {Object|null} Thông tin khu vực đã cache
     */
    getCachedAreaInfo() {
      return this.cachedAreaInfo;
    },

    /**
     * Xóa cache thông tin khu vực
     */
    clearCachedAreaInfo() {
      this.cachedAreaInfo = null;
    },

    /**
     * Kiểm tra xem khu vực trong cache có hợp lệ không
     * @param {Array} availableAreas - Danh sách khu vực có sẵn
     * @returns {boolean} True nếu cache hợp lệ
     */
    isCachedAreaValid(availableAreas) {
      if (!this.cachedAreaInfo || !Array.isArray(availableAreas)) {
        return false;
      }
      
      return availableAreas.some(area => area.area_id === this.cachedAreaInfo.area_id);
    },
  },
  getters: {
    ...areaStore.getters,
    
    /**
     * Kiểm tra có cache khu vực hay không
     * @returns {boolean}
     */
    hasCachedArea: (state) => {
      return state.cachedAreaInfo !== null;
    },
  },
});
